import React, { useState, useEffect, useRef } from "react";
import Logo from "../images/zen-logo.png";
import { Link } from "react-router-dom";
import icon from "../icons/up-right.png";
import { IoMdArrowDropdown } from "react-icons/io";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false); // used for mobile nav
  const [isDropdownOpen, setDropdownOpen] = useState(false); // used for service nav

  const mobileMenuRef = useRef(null);
  const dropdownRef = useRef(null);

  // Close menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false); // Close dropdown when closing the menu
  };

  return (
    <nav className="w-full h-[80px] backdrop-blur-sm bg-white/15 z-50 mt-2 fixed top-0">
      <section className="w-[95%] h-[100%] m-auto flex items-center justify-between">
        <header className="flex items-center gap-2">
          <Link to={"/"} className="flex items-center gap-2" >
          <img
            src={Logo}
            alt="ZenHook Logo"
            className="w-12 h-12 md:w-16 md:h-16"
          />
          <div>
            <h1 className="font-medium text-white text-lg md:text-2xl tracking-[4px]">
              ZenHook
            </h1>
            <p className="font-semibold text-white text-[6px] md:text-[8px]">
              WE WIN FOR OUR CLIENTS, INSPIRED BY OUR ROOTS
            </p>
          </div>
          </Link>
        </header>

        {/* Desktop navigation */}
        <section className="hidden ml-44 lg:flex items-center gap-8 md:gap-14  pr-5">
          <Link
            to="/"
            className="text-white font-extralight hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] transition-all text-base md:text-lg font-poppins"
          >
            Home
          </Link>

          <div
            className="relative w-auto"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <Link
            
              className="hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] text-white font-extralight transition-all text-base md:text-lg font-poppins flex items-center"
            >
              Our Services
              <IoMdArrowDropdown style={{ marginLeft: "5px" }} />
            </Link>
            {/* Dropdown items for desktop */}
            <div
              className={`absolute left-0 mt- rounded-lg w-48 text-start bg-gray-800 text-white transition duration-300 ease-in-out ${
                isDropdownOpen ? "block" : "hidden"
              }`}
              style={{ zIndex: 50 }}
            >
              <Link
                to="/services/webdevelopment"
                className="block px-4 py-2 hover:bg-violet-700 transition-all"
                onClick={closeMenu}
              >
                Web Development
              </Link>
              <Link
                to="/services/ecommercesolutions"
                className="block px-4 py-2 hover:bg-violet-700 transition-all"
                onClick={closeMenu}
              >
                Ecommerce Solutions
              </Link>
              <Link
                to="/services/videomarketing"
                className="block px-4 py-2 hover:bg-violet-700 transition-all"
                onClick={closeMenu}
              >
                Video Marketing
              </Link>
            </div>
          </div>

          <Link
            to="/aboutus"
            className="text-white font-extralight hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] transition-all text-base md:text-lg font-poppins"
          >
            About Us
          </Link>

          <Link
            to="/contact"
            className="text-white font-extralight hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] transition-all text-base md:text-lg font-poppins"
          >
            Contact
          </Link>
        </section>

        {/* Request Demo Button */}
        <section className="hidden lg:block">
          <div className="p-0.5 flex items-center justify-center shadow-lg max-w-[200px] md:max-w-[300px] rounded-[50px] bg-gradient-to-tr from-white to-purple-700">
            <Link to="https://topmate.io/fakir_j?fbclid=PAY2xjawJo2i5leHRuA2FlbQIxMQABp-8xLwlzzB9VWN52SlhkxVXCKHzxvEFQKfQzJAPrTR3GqWD8Sq6pMhI3Zmci_aem_gBWtCOz_Q_euJEnvIar7WQ" className="px-6 md:px-8 py-2 md:py-3 text-base md:text-lg bg-[#232031] justify-center gap-2 rounded-full flex text-white">
              Request demo
              <img src={icon} alt="upright-arrow" className="w-4 h-4" />
            </Link>
          </div>
        </section>

        {/* Mobile menu button */}
        <button
          type="button"
          className="inline-flex items-center justify-center p-2 rounded-full bg-transparent lg:hidden border-transparent"
          aria-controls="mobile-menu"
          aria-expanded={menuOpen ? "true" : "false"}
          onClick={() => setMenuOpen((prev) => !prev)} // This will toggle the menu
        >
          <span className="sr-only">Open main menu</span>
          <div className="bg-transparent rounded-full p-1 w-10 h-10 md:w-16 md:h-10 flex justify-center items-center border-purple-500 border-2 ">
            <svg
              className="w-6 h-6 text-purple-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </div>
        </button>
      </section>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="lg:hidden bg-slate-100/90" ref={mobileMenuRef}>
          <section className="flex flex-col items-center gap-2 p-4">
            <Link
              to="/"
              className="text-black font-extralight hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] transition-all text-lg font-poppins"
              onClick={closeMenu} // Use closeMenu here
            >
              Home
            </Link>

            {/* Mobile dropdown for Our Services */}
            <div className="relative w-full text-center" ref={dropdownRef}>
              <button
                onClick={() => {
                  setDropdownOpen(!isDropdownOpen);
                }}
                className="text-black font-extralight hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] transition-all text-lg font-poppins flex items-center justify-center w-full"
              >
                Our Services
                <IoMdArrowDropdown style={{ marginLeft: "5px" }} />
              </button>
              {/* Dropdown items */}
              <div
                className={`w-full text-center transition duration-300 rounded-xl  ease-in-out ${
                  isDropdownOpen ? "block" : "hidden"
                }`}
              >
                <Link
                  to="/services/webdevelopment"
                  className="block px-4 py-2 hover:bg-violet-700 transition-all"
                  onClick={closeMenu}
                >
                  Web Development
                </Link>
                <Link
                  to="/services/ecommercesolutions"
                  className="block px-4 py-2 hover:bg-violet-700 transition-all"
                  onClick={closeMenu}
                >
                  Ecommerce Solutions
                </Link>
                <Link
                  to="/services/videomarketing"
                  className="block px-4 py-2 hover:bg-violet-700 transition-all"
                  onClick={closeMenu}
                >
                  Video Marketing
                </Link>
              </div>
            </div>

            <Link
              to="/aboutus"
              className="text-black font-extralight hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] transition-all text-lg font-poppins"
              onClick={closeMenu} // Use closeMenu here
            >
              About Us
            </Link>

            <Link
              to="/contact"
              className="text-black font-extralight hover:bg-gradient-to-r from-[#00c3ffab] to-[#d642ccab] px-4 py-2 rounded-[40px] transition-all text-lg font-poppins"
              onClick={closeMenu} // Use closeMenu here
            >
              Contact
            </Link>
          </section>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
